import { Link } from 'react-router-dom';

const columns = [
  {
    heading: 'Solutions',
    links: [
      { label: 'Bookkeeping', to: '/solutions/bookkeeping' },
      { label: 'Close', to: '/solutions/close' },
      { label: 'Reporting', to: '/solutions/reporting' },
      { label: 'Controls', to: '/solutions/controls' },
    ],
  },
  {
    heading: 'Platform',
    links: [
      { label: 'Connect', to: '/connect' },
      { label: 'Pricing', to: '/pricing' },
      { label: 'Resources', to: '/resources' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Log in', to: '/login' },
      { label: 'Start Free Trial', to: '/register' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Terms of Use', to: '/terms' },
      { label: 'Privacy Policy', to: '/privacy' },
      { label: 'Subscription Agreement', to: '/subscription-agreement' },
    ],
  },
];

export default function PublicFooter() {
  return (
    <footer className="relative overflow-hidden" style={{ background: '#0A3622', color: '#F7F6F2' }} data-testid="public-footer">
      <div className="max-w-[1280px] mx-auto px-6 pt-20 pb-10">
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-10 mb-16">
          <div className="col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: '#D98A4A' }}>
                <span className="font-heading text-[15px] font-bold text-white">S</span>
              </div>
              <span className="font-heading text-[17px] font-semibold tracking-tight">SnuggleMind</span>
            </div>
            <p className="text-[13px] leading-relaxed" style={{ color: '#F7F6F2', opacity: 0.7 }}>
              The AI bookkeeping platform built for firms that refuse to wait for the future.
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.heading}>
              <p className="text-[11px] uppercase tracking-[0.2em] font-semibold mb-4" style={{ color: '#D98A4A' }}>{col.heading}</p>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-[13.5px] hover:opacity-100 transition-opacity" style={{ opacity: 0.8 }}>
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between pt-8 gap-3" style={{ borderTop: '1px solid rgba(247,246,242,0.12)' }}>
          <p className="text-[12px]" style={{ opacity: 0.5 }}>&copy; {new Date().getFullYear()} SnuggleMind Inc. All rights reserved.</p>
          <p className="text-[12px] tracking-wide" style={{ opacity: 0.5 }}>Built for modern accounting firms.</p>
        </div>
      </div>

      {/* Giant logomark watermark */}
      <div className="absolute -bottom-20 right-0 pointer-events-none select-none" style={{ opacity: 0.04 }}>
        <span className="font-heading font-black leading-none" style={{ fontSize: '18rem', color: '#F7F6F2' }}>S</span>
      </div>
    </footer>
  );
}
